import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affilation',
  templateUrl: './affilation.component.html',
  styleUrls: ['./affilation.component.css']
})
export class AffilationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
